<template>
  <!-- lineAnalysis 线损列表 -->
  <div class="ut-page-list elec-report-efficiency-analysis container-component" style="background:#03142a">
    <div class="d2-container-full__body">
      <div>
        <div class="custom-crud">
        </div>
        <form class="el-form table-search-form-single el-form--inline flex">
          <div>
            <label style="padding: 0 10px;color: #fff;margin-left:10px">名称：</label>
            <el-select v-model="chartId" placeholder="请选择">
              <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div>
            <label style="padding: 0 10px;color: #fff;margin-left:10px">类型：</label>
            <el-select v-model="itemType" placeholder="请选择">
              <el-option v-for="(item, index) in optionsDate" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="el-form-item form-adaption el-form-item--mini">
            <div v-if="itemType == 'day'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="startTime" type="date" placeholder="选择日期" :picker-options="pickerOptions"
                value-forma="timestamp">
              </el-date-picker>
            </div>
            <div v-if="itemType == 'month'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="startTime" type="date" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM-dd" value-forma="timestamp">
              </el-date-picker>
              <label style="padding: 0 10px;color: #fff">至</label>
              <el-date-picker v-model="endTime" type="date" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM-dd" value-forma="timestamp">
              </el-date-picker>
            </div>
            <div v-if="itemType == 'year'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="startMonthTime" type="month" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM" value-format="timestamp">
              </el-date-picker>
              <label style="padding: 0 10px;color: #fff">至</label>
              <el-date-picker v-model="endMonthTime" type="month" placeholder="选择日期" format="yyyy-MM"
                :picker-options="pickerOptions" value-format="timestamp">
              </el-date-picker>
            </div>
            <div v-if="itemType == '自定义'">
              <label style="padding: 0 10px;color: #fff">查询时间：</label>
              <el-date-picker v-model="customStartTime" type="datetime" placeholder="选择日期"
                :picker-options="pickerOptions" default-time="00:00:00" format="yyyy-MM-dd HH-mm-ss"
                value-format="timestamp">
              </el-date-picker>
              <label style="padding: 0 10px;color: #fff">至</label>
              <el-date-picker v-model="customEndTime" type="datetime" placeholder="选择日期" :picker-options="pickerOptions"
                format="yyyy-MM-dd HH-mm-ss" value-format="timestamp">
              </el-date-picker>
            </div>
          </div>
          <div>
            <el-button icon="el-icon-search">查询</el-button>
            <span v-show="false">{{unitId}}</span>
          </div>
        </form>
        <div class="line-list-row el-row">

          <div class="row-item">
            <div class="box" v-for="index in 10" :key="index">
              <div class="img">
                <img src="../../assets/lossAnalysis/line.png" alt="">
              </div>
              <div class="box_txt">
                <div class="tit">进线{{index}}</div>
                <div class="box_p">进线侧 {{Math.round(Math.random() * 10)}} kWh<i class="el-icon-right"></i>出线侧
                  {{Math.round(Math.random() * 10)}} kWh</div>
                <div class="three">
                  <img src="../../assets/lossAnalysis/rongqi2.png" alt="">
                  <div class="text" style="margin-right: 45px">
                    <div class="t">{{Math.round(Math.random() * 10)}} kWh</div>
                    <span class="b">线损</span>
                  </div>
                  <img src="../../assets/lossAnalysis/rongqi.png" alt="">
                  <div class="text">
                    <div class="t" style="color: #FF8623;">{{Math.round(Math.random() * 10)}}.00%</div>
                    <span class="b">损耗率</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <lossCurve ref="mylossCurve"></lossCurve>
    <losschart ref="mylosschart"></losschart>
  </div>
</template>

<script>
  import lossCurve from "./lossCurve.vue";
  import losschart from "./losschart.vue";
  import { getEnergyLossList } from "../../api/abbNewApi";
  import { diagramHintFind } from "../../api/energyFlow";
  export default {
    components: {
      lossCurve,
      losschart,
    },
    data() {
      return {
        outLine: 0,
        interLine: 0,
        total: 0,//总条数
        pageSize: 9,
        resultTotal: [],
        activeName: "全部",
        itemType: "day", //时间类型
        time: new Date(new Date().toLocaleDateString()), //日 时间
        startTime: new Date(new Date().toLocaleDateString()), //月 开始时间
        endTime: new Date(), //月 结束时间
        startMonthTime: "", //年 开始时间
        endMonthTime: "", // 年 结束时间
        customStartTime: "", //自定义 开始时间
        customEndTime: "", //自定义 结束时间
        // list: [], //数据
        lists1: [],//第一页
        lists: [],//数据
        chartId: '',//ID
        currentPage: 1, //当前页
        // ], //类型数组
        options: [],
        optionsDate: [
          {
            name: "日",
            id: "day"
          },
          {
            name: "月",
            id: "month"
          },
          {
            name: "年",
            id: "year"
          },
        ],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        lineList: [],//损耗阈值
      };
    },
    mounted() {
      this.getEnergyLossFlowByUnitId()

    },
    watch: {
      unitId() {
        this.getEnergyLossFlowByUnitId()
      }
    },
    computed: {
      unitId() {
        return this.$store.unitStore.state.nowUnit
      }
    },
    methods: {
      //损耗阈值
      diagramHintFindFun() {
        diagramHintFind({ 'checked': 0, 'wasteType': 1 }).then(res => {
          this.lineList = res.data
        })
      },
      //处理损耗阈值
      threshold_fn(val) {
        var arr = []
        this.lineList.forEach(item => {
          if (item.color == 'red') {
            if (val > item.thresholdValue) {
              arr.push(item.color)
            }
          } else {
            if (val <= item.thresholdValue) {
              arr.push(item.color)
            }
          }
        })
        return arr.length == 0 ? '' : arr[0]

      },
      handleCurrentChange(e) {
        //   console.log(e)
        this.lists1 = this.lists.slice((e - 1) * this.pageSize, e * this.pageSize);
      },
      //获取下拉数据
      getEnergyLossFlowByUnitId() {
        this.lists = [];
        var res = [
          {
            "createTime": null,
            "id": "183122cbea3e4727a7f4de23d039011c",
            "name": "线损1",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "线损分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "35a8fe485b894111a1fb7f9b6ed4dbcc",
            "name": "变损1",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "变损分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "4277078c52204075ba4cb8c7e3b85cac",
            "name": "12",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "损耗分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "56da66bdd49c41f1823c9a5532a46443",
            "name": "测试",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "线损分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "663527970d70401f87d3b74c70d2c532",
            "name": "能流分析测试2",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "能流分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "68b44a96559841418c438fd5e69f88bc",
            "name": "xx线损",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "线损分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "70ecdd69700b465d807fe60b94c22ad6",
            "name": "4.24",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "能流分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "858cde2c108746a9a9dc68b6143bab18",
            "name": "损耗分析1",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "损耗分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "d7bf7b06f1274c98bc92ceededeb4da5",
            "name": "能流分析-T1",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "能流分析",
            "entityName": "EnergyFlowChart"
          },
          {
            "createTime": null,
            "id": "f6c7de81459c44d6ae95bc8a55951f4c",
            "name": "能流分析-t",
            "unitId": "B5A693FA77804BC8BE009D57D0E7A788",
            "appType": "变损分析",
            "entityName": "EnergyFlowChart"
          }
        ];

        this.options = res.filter(item => item.appType == '线损分析')
        if (this.options.length == 0) {
          this.chartId = ""
          return
        }
        this.chartId = this.options[0].id
        this.FlowLossList()
      },
      //刷新
      update() {
        this.$router.go(0);
      },
      //跳转
      configuration() {
        this.$router.push("./configuration");
      },
      //获取数据
      FlowLossList() {
        var startTime = 0;
        var endTime = 0;
        if (this.itemType == 'day') {
          startTime = this.startTime.getTime() + 1000000
          endTime = this.startTime.getTime() + 24 * 60 * 60 * 1000 - 1
        } else {
          endTime = this.endTime.getTime()
          startTime = this.startTime.getTime()
        }

        var d = {
          nodeId: this.chartId,
          "type": this.itemType,
          "startTime": startTime,
          "endTime": endTime,
          "lossType": 'lineLoss'
        }
        var inSum = 0
        var onSum = 0
        this.lists = [
          {
            "lossName": "出线1",
            "interLine": [
              {
                "interData": 0,
                "name": "永宁机电3数显表",
                "deviceNo": 8
              },
              {
                "interData": 0,
                "name": "永宁机电4数显表",
                "deviceNo": 12
              },
              {
                "interData": 0,
                "name": "益大",
                "deviceNo": 1
              },
              {
                "interData": 0,
                "name": "英派尔预付费表",
                "deviceNo": 19
              },
              {
                "interData": 0,
                "name": "永宁机电2数显表",
                "deviceNo": 7
              },
              {
                "interData": 0,
                "name": "1D2-1+旁路开关（5#变）",
                "deviceNo": -28
              },
              {
                "interData": 0,
                "name": "111",
                "deviceNo": -31
              },
              {
                "interData": 0,
                "name": "晔燃电表",
                "deviceNo": 25
              },
              {
                "interData": 0,
                "name": "永宁机电5数显表",
                "deviceNo": 9
              },
              {
                "interData": 0,
                "name": "利兴强箱变",
                "deviceNo": 5
              },
              {
                "interData": 0,
                "name": "设备no2",
                "deviceNo": 23
              },
              {
                "interData": 0,
                "name": "永宁机电1数显表",
                "deviceNo": 6
              },
              {
                "interData": 0,
                "name": "永兴旺",
                "deviceNo": 3
              },
              {
                "interData": 0,
                "name": "永宁机电总进线数显表",
                "deviceNo": 11
              }
            ],
            "outLine": [],
            "lineLossRate": 1,
            "lineLoss": 2,
            "totalOutLine": 3
          },
          {
            "lossName": "出线2",
            "interLine": [
              {
                "interData": 1,
                "name": "永宁机电4数显表",
                "deviceNo": 12
              }
            ],
            "outLine": [
              {
                "outData": 2,
                "name": "永兴旺",
                "deviceNo": 3
              },
              {
                "outData": 2,
                "name": "利兴强箱变",
                "deviceNo": 5
              },
              {
                "outData": 1,
                "name": "益大",
                "deviceNo": 1
              },
              {
                "outData": 3,
                "name": "英派尔预付费表",
                "deviceNo": 19
              },
              {
                "outData": 1,
                "name": "永宁机电总进线数显表",
                "deviceNo": 11
              }
            ],
            "lineLossRate": 2,
            "lineLoss": 2,
            "totalOutLine": 1
          },
          {
            "lossName": "进线1",
            "interLine": [
              {
                "interData": 1,
                "name": "永宁机电1数显表",
                "deviceNo": 6
              }
            ],
            "outLine": [
              {
                "outData": 2,
                "name": "永宁机电3数显表",
                "deviceNo": 8
              },
              {
                "outData": 1,
                "name": "永宁机电4数显表",
                "deviceNo": 12
              },
              {
                "outData": 2,
                "name": "益大",
                "deviceNo": 1
              },
              {
                "outData": 3,
                "name": "英派尔预付费表",
                "deviceNo": 19
              },
              {
                "outData": 2,
                "name": "永宁机电2数显表",
                "deviceNo": 7
              },
              {
                "outData": 2,
                "name": "1D2-1+旁路开关（5#变）",
                "deviceNo": -28
              },
              {
                "outData": 2,
                "name": "111",
                "deviceNo": -31
              },
              {
                "outData": 0,
                "name": "晔燃电表",
                "deviceNo": 25
              },
              {
                "outData": 1,
                "name": "永宁机电5数显表",
                "deviceNo": 9
              },
              {
                "outData": 1,
                "name": "利兴强箱变",
                "deviceNo": 5
              },
              {
                "outData": 0,
                "name": "设备no2",
                "deviceNo": 23
              },
              {
                "outData": 3,
                "name": "永宁机电1数显表",
                "deviceNo": 6
              },
              {
                "outData": 2,
                "name": "永兴旺",
                "deviceNo": 3
              },
              {
                "outData": 0,
                "name": "永宁机电总进线数显表",
                "deviceNo": 11
              }
            ],
            "lineLossRate": 1,
            "lineLoss": 2,
            "totalOutLine": 1
          },
          {
            "lossName": "出线1",
            "interLine": [
              {
                "interData": 1,
                "name": "永宁机电3数显表",
                "deviceNo": 8
              },
              {
                "interData": 1,
                "name": "永宁机电4数显表",
                "deviceNo": 12
              },
              {
                "interData": 0,
                "name": "益大",
                "deviceNo": 1
              },
              {
                "interData": 4,
                "name": "英派尔预付费表",
                "deviceNo": 19
              },
              {
                "interData": 3,
                "name": "永宁机电2数显表",
                "deviceNo": 7
              },
              {
                "interData": 1,
                "name": "1D2-1+旁路开关（5#变）",
                "deviceNo": -28
              },
              {
                "interData": 1,
                "name": "111",
                "deviceNo": -31
              },
              {
                "interData": 1,
                "name": "晔燃电表",
                "deviceNo": 25
              },
              {
                "interData": 1,
                "name": "永宁机电5数显表",
                "deviceNo": 9
              },
              {
                "interData": 2,
                "name": "利兴强箱变",
                "deviceNo": 5
              },
              {
                "interData": 3,
                "name": "设备no2",
                "deviceNo": 23
              },
              {
                "interData": 3,
                "name": "永宁机电1数显表",
                "deviceNo": 6
              },
              {
                "interData": 3,
                "name": "永兴旺",
                "deviceNo": 3
              },
              {
                "interData": 3,
                "name": "永宁机电总进线数显表",
                "deviceNo": 11
              }
            ],
            "outLine": [],
            "lineLossRate": 3,
            "lineLoss": 3,
            "totalOutLine": 1
          },
          {
            "lossName": "进线2",
            "interLine": [
              {
                "interData": 2,
                "name": "永宁机电1数显表",
                "deviceNo": 6
              }
            ],
            "outLine": [
              {
                "outData": 0,
                "name": "永宁机电4数显表",
                "deviceNo": 12
              }
            ],
            "lineLossRate": 1,
            "lineLoss": 1,
            "totalOutLine": 2
          },
          {
            "lossName": "出线2",
            "interLine": [
              {
                "interData": 1,
                "name": "永宁机电4数显表",
                "deviceNo": 12
              }
            ],
            "outLine": [
              {
                "outData": 0,
                "name": "永兴旺",
                "deviceNo": 3
              },
              {
                "outData": 0,
                "name": "利兴强箱变",
                "deviceNo": 5
              },
              {
                "outData": 0,
                "name": "益大",
                "deviceNo": 1
              },
              {
                "outData": 0,
                "name": "英派尔预付费表",
                "deviceNo": 19
              },
              {
                "outData": 0,
                "name": "永宁机电总进线数显表",
                "deviceNo": 11
              }
            ],
            "lineLossRate": 2,
            "lineLoss": 1,
            "totalOutLine": 3
          }
        ];
        this.lists.forEach(item => {
          inSum = 2
          onSum = 1
          item.interLine.forEach(t => {
            inSum += Number(t.interData)
          })
          item.interLineSum = Math.round(inSum * 100) / 100
          item.outLine.forEach(t => {
            onSum += Number(t.outData)
          })
          item.outLineSum = Math.round(onSum * 100) / 100
        })
        this.diagramHintFindFun() //获取损耗阈值


      },
      //查询
      demand() {

        if (this.itemType == "日") {
          this.FlowLossList("custom", this.startTime.getTime(), this.endTime.getTime())
        } else if (this.itemType == "月") {
          this.FlowLossList("custom", this.startTime.getTime(), this.endTime.getTime())
        } else if (this.itemType == "年") {
          this.FlowLossList("custom", this.startMonthTime, this.endMonthTime)
        } else {
          this.FlowLossList("custom", this.customStartTime, this.customEndTime)
        }
      },
      //损耗曲线
      lossCurveInit() {
        this.$nextTick(() => {
          this.$refs.mylossCurve.initn();
        });
      },
      losschart() {
        this.$nextTick(() => {
          this.$refs.mylosschart.initn();
        });
      },
      //下拉框选择
      handleSelect(key) {
        this.activeIndex = key;
      },

    },
  };
</script>
<style>
  .container-component .el-button {
    color: #fff !important;
  }

  .container-component .el-input--suffix .el-input__inner {
    color: #fff !important;
  }

  .container-component .el-select .el-input__inner {
    color: #fff !important;
  }
</style>
<style scoped lang="scss">
  .box {
    color: #fff;
    width: 296px;
    height: 300px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #05224C;
    border: 1px solid #0E5DCD;
    margin-right: 12px;
    margin-bottom: 12px;

    .img {
      display: flex;
      width: 280px;
      height: 168px;
      border-radius: 8px;
      margin: 8px;
      background-color: #051a38;
      justify-content: center;

      img {
        width: 100px;
        width: 165px;
      }

    }

    .box_txt {
      margin-left: 20px;

      .tit {
        font-size: 18px;
      }

      .box_p {
        font-size: 12px;
        display: flex;
        margin: 5px 0;
      }

      .three {
        display: flex;
        align-items: center;
        margin-top: 13px;

        img {
          margin-right: 5px;
        }

        .t {
          font-family: Microsoft YaHei;
          font-size: 18px;
          font-weight: bold;
          color: #FFB914;
        }

        .b {
          font-size: 12px;
        }
      }
    }

  }

  .row-item {
    display: flex;
    flex-wrap: wrap;

    .item {
      flex-shrink: 0;
      width: 454px;
      height: 314px;
      background-color: #143A76;
      border-radius: 5px;
      padding: 15px;
      color: #000;
      margin-right: 20px;
      margin-bottom: 20px;

      .item-title {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .item-middle {
        display: flex;

        .z-left {
          width: 200px;
          height: 200px;
          // border: 1px solid red;
          margin-right: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .z-right {
          .z-name {
            height: 36px;
            // line-height: 36px;
            display: flex;
            align-items: center;

            span {
              margin-left: 6px;
              font-size: 15px;
              font-weight: bold;
            }


          }

          .yellow {
            color: #FFC738;
            font-size: 30px;
            font-weight: bold;
            margin-top: 15px;
            margin-bottom: 25px;
          }

          .red {
            color: #FF7A50;
            font-size: 30px;
            font-weight: bold;
            margin-top: 15px;
          }
        }

      }

      .item-bottm {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        margin-top: 20px;
      }

    }
  }

  .d2-container-full__body {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    /* height: 100%; */
    /* padding: 20px; */
    overflow: auto;
    position: relative;
  }

  /deep/.el-button {
    background-color: transparent !important;
    color: #000;
    height: 32px;
    line-height: 32px;
    padding: 0px 20px;

    &:hover {
      border-color: #409eff;
      background-color: #409eff !important;
    }
  }

  .ut-page-title-actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 52px;
    padding: 0 15px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #f8f8f9;
  }

  .custom-crud {
    padding: 5px 15px 10px;
    /* background-color: #000; */
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .flex {
    display: flex;
  }

  /deep/.el-menu--horizontal>.el-menu-item {
    height: 40px;
    line-height: 40px;
  }

  .ut-page-title-actions .page-title-text {
    -webkit-box-flex: 1px;
    -ms-flex: 1px;
    flex: 1px;
    padding: 10px 7px;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .ut-page-title-actions .el-button {
    font-size: 14px;
    padding: 0 10px;
    position: relative;
    margin-left: 0;
  }

  .ut-page-list .el-form {
    /* background-color: #000; */
    /* padding: 35px 15px 0 25px; */
  }

  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 18px;
  }

  .ut-page-list .table-search-form-single .form-adaption {
    margin-right: 25px;
  }

  /deep/.el-input--suffix .el-input__inner {
    height: 32px;
    line-height: 32px;
    /* border-radius: 25px; */
    background-color: transparent;
    color: #000;
  }

  .ut-page-list .table-search-form-single .form-adaption .search-form-select input {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    color: #000;
    /* border-radius: 25px; */
  }

  /deep/.el-input__icon {
    line-height: 32px;

  }

  /deep/.el-button--small {
    padding: 3px 20px;
    border-radius: 20px;
  }

  .line-list-row {
    width: 100%;
    padding-top: 10px;
    margin: 0;
    /* background-color: #000; */
    min-height: 750px;
    padding-left: 19px;
    padding-bottom: 50px;
  }

  .el-row:after,
  .el-row:before {
    display: table;
  }

  .ut-page-list .custom-card .el-card__body {
    padding: 10px;
  }

  .list {
    padding-left: 10px;
    padding-right: 10px;
    min-height: 176px;
    margin-bottom: 20px;
    display: table;
  }

  .el-card {
    border: 1px solid #ebeef5;
    background-color: #000;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    display: table-cell;
  }

  .el-row--flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .card-head-title {
    font-size: 15px;
    color: #000;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding-right: 5px;
  }

  .card-head-no {
    color: #909399;
  }

  .card-body {
    padding: 10px 0;
  }

  .el-row--flex.is-justify-space-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .card-body .grid-content>div {
    font-size: 13px;
    /*display: inline-block;*/
    /* width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
  }

  .card-body .grid-content .loss-info-value {
    padding: 7px 0;
  }

  .number {
    color: #303133;
    font-size: 24px;
    margin-right: 5px;
  }

  .el-col-0,
  .el-row--flex:after,
  .el-row--flex:before {
    display: none;
  }

  [class*="el-col-"] {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .card-body .grid-content {
    color: #909399;
    padding-left: 5px;
  }

  .card-bottom {
    border-top: 1px solid #ebeef5;
  }

  .card-bottom .btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 8px;
  }

  .card-bottom .btn .el-button {
    color: #909399;
  }

  .card-bottom .bd {
    border-left: 1px solid #ebeef5;
  }

  .color {
    color: rgb(244, 67, 54);
  }

  .ut-page-list .custom-crud {
    /* background-color: #000; */
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    text-align: right;
  }

  .ut-page-list .custom-crud .d2-crud-pagination {
    padding: 15px !important;
  }

  /deep/.el-menu {
    background: #fff !important;
  }

  /deep/.el-menu-item.is-active {
    background: #fff !important;
  }

  /deep/.el-menu-item-group .el-menu-item.demo:hover {
    background: #fff !important;
  }

  .t {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box !important;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
</style>